module.exports = __webpack_public_path__ + "static/img/rb_rz.445ae4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rb_rz.png
// module id = cHME
// module chunks = 0